if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        let variant_selects = document.querySelector('variant-selects');
        if ( !variant_selects ) {
          // Single variant product
          this.chkMedicalAgree = document.getElementById('cart_medical_agree');
          if (this.chkMedicalAgree) {
            this.chkMedicalAgree.addEventListener('change', e => {
              this.submitButton.disabled = this.form.dataset.available === 'false' ? true : !this.chkMedicalAgree.checked;
              this.submitButton.setAttribute('aria-disabled', this.submitButton.disabled);
            });
          }
        }

        // Init gift card form
        this.is_gift_card_product = (this.closest('section').dataset.isGift === 'true');
        if (this.is_gift_card_product) {
          this._initGiftCardProductForm();
        }

        // For someone else
        this.chkIsGIft = document.getElementById('its-a-gift');
        if (this.chkIsGIft) {
          this.chkIsGIft.addEventListener('change', e => {
            if (this.chkIsGIft.checked) {
              $("#gift-email-section").css("display", "block");
              $("#gift-recipient-email").attr("required", "required");
              $("#gift-recipient-email-confirmation").attr("required", "required");
              $("#gift-recipient-first-name").attr("required", "required");
              $("#gift-recipient-last-name").attr("required", "required");
            } else {
              $("#gift-email-section").hide();
              $("#gift-recipient-email").removeAttr("required");
              $("#gift-recipient-email-confirmation").removeAttr("required");
              $("#gift-recipient-first-name").removeAttr("required");
              $("#gift-recipient-last-name").removeAttr("required");
            }
          });
        }
      }

      _initGiftCardProductForm() {
        $("#gift-email-section input").on('blur', () => {
          this.submitButton.disabled =  !document.forms.frm_gift.reportValidity();
          this.submitButton.setAttribute('aria-disabled', this.submitButton.disabled);
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const chk_gift = document.getElementById('its-a-gift');
        if ( (chk_gift && chk_gift.checked) || this.is_gift_card_product ) {
          // Validate gift form
          if ( !document.forms.frm_gift.reportValidity() ) {
            return;
          }

          // Compare two email fields
          if (document.getElementById('gift-recipient-email').value != document.getElementById('gift-recipient-email-confirmation').value) {
            document.getElementById('gift-recipient-email-confirmation').focus();
            toastr.error("Emails don't match");
            return;
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);

          this.cart.setActiveElement(document.activeElement);
        }

        /* For someone else */
        if ( (chk_gift && chk_gift.checked) || this.is_gift_card_product ) {
          formData.append('properties[Recipient Email]', document.getElementById('gift-recipient-email').value);
          formData.append('properties[Recipient First Name]', document.getElementById('gift-recipient-first-name').value);
          formData.append('properties[Recipient Last Name]', document.getElementById('gift-recipient-last-name').value);
        }
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        /*
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
        */

        if (errorMessage) {
          toastr.error(errorMessage);
        } else {
          toastr.clear();
        }
      }
    }
  );
}